import { Component, OnInit } from "@angular/core";
import { LanguageSwitchService } from "../../Services/LanguageSwitch/language-switch.service";
@Component({
  selector: "app-footer-section",
  templateUrl: "./footer-section.component.html",
  // styleUrls: ['./footer-section.component.css']
  styleUrls: ["../../app.component.css", "./footer-section.component.css"],
})
export class FooterSectionComponent implements OnInit {
  config;
  constructor(private ls: LanguageSwitchService) {
    this.ls.config.subscribe({
      next: (config) => {
        this.config = config;
      },
    });
  }

  ngOnInit() {}
}
